import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
function OnePageSideButton({handleCartPopup}) {
  const [cartlength, setCartLength] = useState(0);
  const [storeData, setStoreData] = useState(null);

  const selectedOption = useSelector((state) => state.product.productId);

  // const handleCartPopup = () => {
  //   console.log("clickcart");
  // };

  const getStoreInfo = () => {
    axios
      .get("/api/Home/StoreData", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const responseData = response.data;
        console.log("回傳的StoreData", "responseData");
        setStoreData(responseData);
        // setSideForMb(responseData.sidebarNavForMobile);
        console.log("storeData.socialLine", "responseData.socialLine");
      })
      .catch((error) => {
        console.error("StoreData有錯誤：", "error");
        console.error(
          "寄送StoreData出現的錯誤訊息",
          "error.response.data.message"
        );
      });
  };
  const PcCartButton = (key, navname) => {
    return (
      <div className={`side-button`} onClick={handleCartPopup} key={key}>
        <div className="wrap">
          <div className="wrap-svg">
            {/* <img src={icon} alt={navname} title={navname} /> */}

            <div className="cart-amouunt">{cartlength}</div>
            <div className="wrap-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 38"
                fill="none"
              >
                <path
                  d="M39.4115 8.26358C39.0546 7.64518 38.5435 7.12984 37.9281 6.76783C37.3126 6.40581 36.6139 6.20948 35.9 6.19799H9.46041L8.26237 1.52975C8.14132 1.07912 7.87127 0.682741 7.49619 0.405183C7.12111 0.127625 6.66311 -0.0147623 6.19678 0.00121143H2.06559C1.51776 0.00121143 0.992371 0.218836 0.604998 0.606209C0.217624 0.993583 0 1.51897 0 2.0668C0 2.61463 0.217624 3.14002 0.604998 3.5274C0.992371 3.91477 1.51776 4.1324 2.06559 4.1324H4.62693L10.328 25.3254C10.449 25.776 10.7191 26.1724 11.0941 26.4499C11.4692 26.7275 11.9272 26.8699 12.3936 26.8539H30.9839C31.3653 26.8527 31.739 26.746 32.0635 26.5455C32.388 26.3449 32.6506 26.0585 32.8223 25.7178L39.5974 12.1675C39.8911 11.552 40.0278 10.8734 39.9953 10.1922C39.9629 9.51098 39.7623 8.8484 39.4115 8.26358Z"
                  fill="#00692E"
                />
                <path
                  d="M11.3608 37.1816C13.072 37.1816 14.4592 35.7944 14.4592 34.0833C14.4592 32.3721 13.072 30.9849 11.3608 30.9849C9.64965 30.9849 8.26245 32.3721 8.26245 34.0833C8.26245 35.7944 9.64965 37.1816 11.3608 37.1816Z"
                  fill="#00692E"
                />
                <path
                  d="M32.0167 37.1816C33.7279 37.1816 35.1151 35.7944 35.1151 34.0833C35.1151 32.3721 33.7279 30.9849 32.0167 30.9849C30.3055 30.9849 28.9183 32.3721 28.9183 34.0833C28.9183 35.7944 30.3055 37.1816 32.0167 37.1816Z"
                  fill="#00692E"
                />
              </svg>
            </div>
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">{navname}</h4>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const PcLinkButton = (key, navname, navurl, svg) => {
    return (
      <Link to={`${navurl}`}  target="_blank"  replace={false}  className="side-button" key={key}>
        <div className="wrap">
          <div className="wrap-svg">
            <div className="wrap-icon">
              {svg === "mail" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 33"
                  fill="none"
                >
                  <rect
                    y="0.181641"
                    width="40"
                    height="30"
                    rx="10"
                    fill="white"
                  />
                  <path
                    d="M36 28.1816H32V10.6816L20 18.1816L8 10.6816V28.1816H4V4.18164H6.4L20 12.6816L33.6 4.18164H36M36 0.181641H4C1.78 0.181641 0 1.96164 0 4.18164V28.1816C0 29.2425 0.421427 30.2599 1.17157 31.0101C1.92172 31.7602 2.93913 32.1816 4 32.1816H36C37.0609 32.1816 38.0783 31.7602 38.8284 31.0101C39.5786 30.2599 40 29.2425 40 28.1816V4.18164C40 3.12077 39.5786 2.10336 38.8284 1.35321C38.0783 0.603068 37.0609 0.181641 36 0.181641Z"
                    fill="#00692E"
                  />
                </svg>
              )}
              {svg === "line" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 41"
                  fill="none"
                >
                  <rect
                    y="0.181641"
                    width="40"
                    height="40"
                    rx="20"
                    fill="white"
                  />
                  <path
                    d="M24.2969 15.5566V21.9082C24.2969 22.0723 24.1719 22.1973 24.0078 22.1973H22.9922C22.8906 22.1973 22.8047 22.1426 22.7578 22.0801L19.8438 18.1504V21.916C19.8438 22.0801 19.7188 22.2051 19.5547 22.2051H18.5391C18.375 22.2051 18.25 22.0801 18.25 21.916V15.5645C18.25 15.4004 18.375 15.2754 18.5391 15.2754H19.5469C19.6328 15.2754 19.7344 15.3223 19.7812 15.4004L22.6953 19.3301V15.5645C22.6953 15.4004 22.8203 15.2754 22.9844 15.2754H24C24.1641 15.2676 24.2969 15.4004 24.2969 15.5488V15.5566ZM16.9766 15.2676H15.9609C15.7969 15.2676 15.6719 15.3926 15.6719 15.5566V21.9082C15.6719 22.0723 15.7969 22.1973 15.9609 22.1973H16.9766C17.1406 22.1973 17.2656 22.0723 17.2656 21.9082V15.5566C17.2656 15.4082 17.1406 15.2676 16.9766 15.2676ZM14.5234 20.5879H11.7422V15.5566C11.7422 15.3926 11.6172 15.2676 11.4531 15.2676H10.4375C10.2734 15.2676 10.1484 15.3926 10.1484 15.5566V21.9082C10.1484 21.9863 10.1719 22.0488 10.2266 22.1035C10.2813 22.1504 10.3438 22.1816 10.4219 22.1816H14.5C14.6641 22.1816 14.7891 22.0566 14.7891 21.8926V20.877C14.7891 20.7285 14.6641 20.5879 14.5156 20.5879H14.5234ZM29.6562 15.2676H25.5703C25.4219 15.2676 25.2812 15.3926 25.2812 15.5566V21.9082C25.2812 22.0566 25.4062 22.1973 25.5703 22.1973H29.6484C29.8125 22.1973 29.9375 22.0723 29.9375 21.9082V20.8848C29.9375 20.7207 29.8125 20.5957 29.6484 20.5957H26.875V19.5332H29.6484C29.8125 19.5332 29.9375 19.4082 29.9375 19.2441V18.2207C29.9375 18.0566 29.8125 17.9316 29.6484 17.9316H26.875V16.8613H29.6484C29.8125 16.8613 29.9375 16.7363 29.9375 16.5723V15.5566C29.9297 15.4082 29.8047 15.2676 29.6484 15.2676H29.6562ZM40 7.47853V32.9473C39.9922 36.9473 36.7109 40.1894 32.7031 40.1816H7.23438C3.23439 40.1738 -0.00779841 36.8848 1.40894e-05 32.8848V7.41603C0.00782658 3.41603 3.29689 0.173842 7.29688 0.181655H32.7656C36.7656 0.189467 40.0078 3.47072 40 7.47853ZM34.5 18.4238C34.5 11.9082 27.9609 6.60353 19.9375 6.60353C11.9141 6.60353 5.37501 11.9082 5.37501 18.4238C5.37501 24.2598 10.5547 29.1582 17.5547 30.0879C19.2578 30.4551 19.0625 31.0801 18.6797 33.3769C18.6172 33.7441 18.3828 34.8144 19.9375 34.166C21.4922 33.5176 28.3203 29.2285 31.3828 25.7129C33.4922 23.3926 34.5 21.041 34.5 18.4395V18.4238Z"
                    fill="#00692E"
                  />
                </svg>
              )}
            </div>
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">{navname}</h4>
            </div>
          </div>
        </div>
      </Link>
    );
  };
  useEffect(() => {
    const cartData = localStorage.getItem("onepagecart");
    const cartArray = cartData ? JSON.parse(cartData) : [];
    setCartLength(cartArray.length);
    console.log("cartlength", "cartlength");
  }, [selectedOption]);
  useEffect(() => {
    getStoreInfo();
  }, []);
  return (
    <>
      {storeData && (
        <div className="side-button-container">
          {PcCartButton("cart", "購物車")}
          {PcLinkButton("mail", "E-mail", `mailto:${storeData.contactEmail}`, "mail")}
          {PcLinkButton("line", "線上諮詢", storeData.socialLine, "line")}
        </div>
      )}
    </>
  );
}

export default OnePageSideButton;
